import React, { Component } from "react"
import { Paper, CircularProgress } from "material-ui"
import autobind from "class-autobind"
import strings from "../../../../localization/strings"
import AddUserDetailExpenseDialog from "../../../../components/expense/AddUserDetailExpenseDialog"
import UserDetailExpensesTable from "../../../../components/expense/UserDetailExpensesTable"
import TableActionBar from "../../../../components/layout/TableActionBar"
import { ELoggedInUserType, IExpenseDocument, IJobDocument, IUserDocument, IExpenseTemplate, IPayrollPayGroupData } from "../../../../models"
import moment from "moment"
import { FloatingActionButton } from "material-ui"
import ContentAdd from "material-ui/svg-icons/content/add"
import AppStateStore from "../../../../stores/AppStateStore"
import * as payGroupAndTypeHelper from "../../../../helpers/payGroupAndTypeHelper"

interface IProps {
    readonly?: boolean
    loading: boolean
    job: IJobDocument
    expenses: IExpenseTemplate[]
    tableName: string
    showFrequencyControl?: boolean | null
    getExpenses: () => void
    addExpense: (jobId: string, expense: IExpenseTemplate) => void
    deleteExpense: (jobId: string, expenses: string[]) => void
    updateExpense: (jobId: string, expense: IExpenseTemplate) => void
    isOneTime?: boolean
}
interface IState {
    openAddExpenseDialog: boolean
    editExpense: IExpenseDocument
    selectedExpenses: IExpenseDocument[]
}

export default class ExpenseGrid extends Component<IProps, IState> {
    constructor(props) {
        super(props)
        this.state = {
            openAddExpenseDialog: false,
            editExpense: null,
            selectedExpenses: []
        }
        autobind(this)
    }

    render() {
        const jobPayGroupId = payGroupAndTypeHelper.getPayGroupIdByUserPayrollData(
            {
                Id: null,
                PayrollHierarchyItemId: this.props.job.HierarchyId,
                PayrollPayGroupId: null,
                DefaultPunchHierarchyId: this.props.job.HierarchyId,
                DefaultJobId: this.props.job.Id
            },
            this.props.job
        )
        return (
            <Paper zDepth={1} style={{ marginBottom: "50px", padding: 0.1 }}>
                <div style={{ position: "relative" }}>
                    {!this.props.readonly &&
                        <FloatingActionButton data-intercom-target={`menu-Jobs-JobDetails-ExpensesTab-${this.props.tableName}-Btn-Add`} className="fixed-add" style={{ right: 50, top: -30, zIndex: 998 }} secondary onTouchTap={() => this.setState({ openAddExpenseDialog: true })}>
                            <ContentAdd />
                        </FloatingActionButton>
                    }
                </div>
                <TableActionBar
                    searchText={""}
                    rowSelectionCount={this.state.selectedExpenses.length}
                    singleSelectedMessage={strings.Expense_Selected}
                    multipleSelectedMessage={strings.x_Expenses_Selected}
                    title={strings.Expenses}
                    onDeleteClick={() =>
                        AppStateStore.setConfirmDialogContent({
                            content: strings.Are_you_sure_you_want_to_delete_selected_expense,
                            confirm: () => {
                                this.props.deleteExpense(this.props.job.Id, this.state.selectedExpenses.map((x) => x.Id))
                                this.setState({ selectedExpenses: [] })
                            }
                        })
                    }
                    readonly={this.props.readonly}
                />
                <div style={{ fontSize: 15, fontWeight: "bold", padding: 25 }}>{this.props.tableName}</div>
                {this.props.loading ?
                    <div className="spinner">
                        <CircularProgress />
                    </div> :
                    !this.props.expenses.length ?
                        <h2 style={{ textAlign: "center", marginTop: 10 }}>{strings.No_expense_found}</h2> :
                        <UserDetailExpensesTable
                            showExported={false}
                            readonly={this.props.readonly}
                            expenses={this.props.expenses.map((x) => x.Expense)}
                            selectedExpenses={this.state.selectedExpenses}
                            handleSelect={(selectedExpenses) => this.setState({ selectedExpenses: selectedExpenses as IExpenseDocument[] })}
                            handleUpdate={(editExpense) => {
                                this.setState({ openAddExpenseDialog: true, editExpense: editExpense as IExpenseDocument })
                            }}
                        />
                }
                {this.state.openAddExpenseDialog &&
                    <AddUserDetailExpenseDialog
                        loggedInUserType={ELoggedInUserType.AccountAdmin}
                        employee={{ PayrollHierarchyItemId: this.props.job.HierarchyId, PayrollPayGroupId: jobPayGroupId, DefaultHierarchyItemId: this.props.job.HierarchyId, DefaultPunchHierarchyId: this.props.job.HierarchyId, DefaultJobId: this.props.job.Id } as IUserDocument}
                        payrollDataForPayGroup={{
                            PayrollHierarchyItemId: this.props.job.HierarchyId,
                            PayrollPayGroupId: jobPayGroupId
                        } as IPayrollPayGroupData}
                        job={this.props.job}
                        payPeriodReferenceDate={moment().format()}
                        editExpense={this.state.editExpense}
                        handleClose={() => this.setState({ openAddExpenseDialog: false, editExpense: null })}
                        handleAdd={(expenseBundle, expenseScheduleType) => this.props.addExpense(expenseBundle.Expense.JobId, { Id: expenseBundle.Expense.Id, Expense: expenseBundle.Expense, ExpenseScheduleType: expenseScheduleType })}
                        handleUpdate={(expenseBundle, expenseScheduleType) => this.props.updateExpense(expenseBundle.Expense.JobId, { Id: expenseBundle.Expense.Id, Expense: expenseBundle.Expense, ExpenseScheduleType: expenseScheduleType })}
                        showFrequencyControl={this.props.showFrequencyControl}
                        frequency={this.state.editExpense ? this.props.expenses.find((x) => x.Expense.Id === this.state.editExpense.Id).ExpenseScheduleType : 0}
                        isOneTime={this.props.isOneTime}
                        payDate={null}
                        payrollHierarchyId={null}
                        payrollPayGroupId={null}
                    />
                }
            </Paper>
        )
    }
}
